import React from 'react';
import { Log } from 'ng2-logger';
import Translator from '../../../core/i18n';
const T = Translator.create();
const _logger = Log.create('validete-ınput');

const IsValidComponent = (props: any) => {
    if (props.touched || props.isSubmitting > 0) {
        if (props.errors) {
            return (
                <>
                    <span style={{ borderBottomColor: '#ff6f61' }} className="validate-span" />
                    <div className="error">{props.errors}</div>
                </>
            );
        } else if (props.value && props.value.length) {
            return props.name !== 'oldPassword' ? (
                <>
                    <span style={{ borderBottomColor: '#39b27b' }} className="validate-span" />
                    {/* <div className="success">{T.t('r_gen_success')}</div> */}
                </>
            ) : null;
        }
    }
    return null;
};

export default IsValidComponent;
